const pad = (value, length, padString) => {
  if (!length || !padString) {
    return value;
  }

  return String(value).padStart(length, padString);
};

export default pad;
